import React from 'react';

import { FormattedMessage } from 'react-intl';

import { MDash } from 'ui-components/components/mdash';
import { Text, TextType } from 'ui-components/components/text';

import LabeledField from './labeled-field';
import messages from './messages';
import { EmailAddress } from '../../../../components/contact-info/email-address';
import { PhoneNumber } from '../../../../components/contact-info/phone-number';
import { Username } from '../../../../components/contact-info/username';
import { useEntitiesSalesOrder } from '../../../../hooks/entities/selectors/sales-orders';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';

import style from './order-summary.module.less';

const SoldTo = () => {
  const salesOrderId = useSalesOrderIdContext();
  const { soldTo } = useEntitiesSalesOrder(salesOrderId) ?? {};

  const { name, phone, email, username } = soldTo ?? {};

  const hasName = !!name;
  const hasPhone = !!phone;
  const hasEmail = !!email;
  const hasUsername = !!username;
  const showSoldTo = hasName || hasPhone || hasEmail || hasUsername;

  return (
    <LabeledField label={<FormattedMessage {...messages.soldToLabel} />}>
      {showSoldTo ? (
        <div className={style['field-content']}>
          {hasName && <Text textType={TextType.Paragraph} value={name} />}
          {hasPhone && <PhoneNumber phoneNumber={phone} />}
          {hasEmail && <EmailAddress emailAddress={email} />}
          {hasUsername && <Username username={username} />}
        </div>
      ) : (
        <MDash className={style['field-content']} />
      )}
    </LabeledField>
  );
};

export default SoldTo;
